import React from 'react';
import { Helmet } from "react-helmet";

import { Container } from "react-bootstrap";

function PrivacyPolicy() {

	return (

		<>
			<Helmet>
				<title>Privacy Policy</title>
			</Helmet>

			<Container>

				<h3 style={{ fontSize: '3vw' }}>PRIVACY POLICY</h3>
				<h5 style={{ fontSize: '3vw' }}>Kestrel Intelligence di Vitiello Claudio Filippo</h5>

				<p><strong>INTRODUZIONE</strong></p>

				<p>A seguito della consultazione di questo sito web possono essere trattati dati relativi a persone identificate o identificabili. Di conseguenza, rendiamo con il presente documento l'informativa al trattamento dei dati personali, ai sensi di quanto previsto dall'art. 13 del Regolamento UE 2016/679, dal d.lgs 196/2003 e successive modifiche e integrazioni, nonchè della normativa applicabile in merito al trattamento dei dati personali (di seguito <strong>'Normativa Privacy'</strong>).</p>
				<p><strong>TITOLARE DEL TRATTAMENTO</strong></p>
				<p>Il Titolare del trattamento dei dati da Lei forniti è Kestrel Intelligence di Vitiello Claudio Filippo, società di diritto italiano, Corso Giolitti 17, 12100 - Cuneo (CN), Partita IVA n. 04154210043 (di seguito il <strong>'Titolare'</strong>).</p>

				<p><strong>TIPOLOGIA DEI DATI TRATTATI</strong></p>
				<p>Il Titolare potrà trattare diverse tipologie di dati personali (i <strong>'Dati'</strong>), in funzione dei servizi e delle funzionalità del Sito.</p>
				<p>I Dati oggetto di trattamento possono essere i seguenti:</p>
				<div>
					<ul >
						<li><strong>Dati anagrafici e identificativi</strong></li>
					</ul>
				</div>
				<p>Nome e cognome, data di nascita;</p>
				<div>
					<ul>
						<li><strong>Dati di contatto</strong></li>
					</ul>
				</div>
				<p>Email, numero di telefono</p>
				<div>
					<ul>
						<li><strong>Dati di navigazione</strong></li>
					</ul>
				</div>
				<p >I sistemi informatici e le procedure software preposte al funzionamento di questo Sito potrebbero acquisire, nel corso del loro normale esercizio, alcuni dati personali la cui trasmissione è implicita nell'uso dei protocolli di comunicazione di Internet. Si tratta di informazioni che non sono raccolte per essere associate a interessati identificati, ma che per loro stessa natura potrebbero, attraverso elaborazioni ed associazioni con dati detenuti da terzi, permettere di identificare utenti. In questa categoria di dati rientrano gli indirizzi IP o i nomi a dominio dei computer utilizzati dagli utenti che si connettono al Sito, gli indirizzi in notazione URI (Uniform Resource Identifier) delle risorse richieste, l'orario della richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto in risposta, il codice numerico indicante lo stato della risposta data dal server (buon fine, errore, etc...) ed altri parametri relativi al sistema operativo ed all'ambiente informatico dell'utente.</p>

				<p>Questi dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del Sito e per controllarne il corretto funzionamento e vengono cancellati immediatamente dopo l'elaborazione. I dati potrebbero essere utilizzati per l'accertamento di responsabilità in caso di ipotetici reati informatici ai danni del Sito: salva questa eventualità, allo stato i dati sui contatti web non persistono per più di sette giorni.</p>
				<div>
					<ul>
						<li><strong>Dati forniti volontariamente dall'utente</strong></li>
					</ul>
				</div>

				<p>Per la mera consultazione del Sito non è richiesto alcun conferimento di dati personali da parte dell'utente. L'invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo Sito comporta la successiva acquisizione dell'indirizzo del mittente, necessario per rispondere alle richieste, nonchè degli eventuali altri dati personali inseriti nella missiva. Tali dati saranno utilizzati al solo fine di dar seguito alla richiesta dell'utente e potranno essere comunicati a terzi solo nel caso in cui ciò sia necessario a tal fine.</p>
				<div>
					<ul>
						<li><strong>Cookies</strong></li>
					</ul>
				</div>

				<p>Per le informazioni relative ai cookies presenti sul Sito si rinvia alla Cookie Policy.</p>
				<p>Alcuni dati potranno essere richiesti in forma obbligatoria in quanto necessari ai fini dell'erogazione del servizio richiesto. Il mancato inserimento di tali dati potrebbe comportare l'impossibilità di completare la registrazione e di usufruire pertanto di alcuni servizi del Sito.</p>

				<p><strong>BASI GIURIDICHE E FINALITA' DEL TRATTAMENTO</strong></p>
				<p>Il Titolare potrà trattare i suoi Dati per diverse finalità, in funzione dei prodotti, dei servizi e delle funzionalità del Sito. Il trattamento dei Dati avverrà per la finalità e secondo le basi giuridiche di seguito indicate:</p>
				<div>
					<ul>
						<li ><strong>Contatti:</strong> invio facoltativo, esplicito e volontario di posta elettronica agli indirizzi indicati su questo Sito o comunque di un messaggio con le altre forme di contatto indicate nel Sito comporta la successiva acquisizione dell'indirizzo del mittente, necessario per rispondere alle richieste, nonchè degli eventuali altri dati personali inseriti nella missiva. Tali dati saranno utilizzati al solo fine di dar seguito alla richiesta dell'utente e potranno essere comunicati a terzi solo nel caso in cui ciò sia necessario a tal fine.</li>
					</ul>
				</div>
				<p>La base giuridica del trattamento è costituita dagli obblighi contrattuali nonchè, ove applicabile, dall'obbligo legale.</p>

				<p><strong>MODALITA' DEL TRATTAMENTO</strong></p>
				<p>Il trattamento e l'elaborazione dei Dati avverrà mediante strumenti manuali ed informatici, in modo da garantire la sicurezza e la riservatezza dei dati nel rispetto della normativa applicabile in materia di protezione dei dati personali.</p>
				<p>I Dati potranno essere comunicati a soggetti terzi qualificati come Responsabili del trattamento, esclusivamente per le attività connesse alle finalità previste nella presente privacy policy.</p>
				<p>I dati personali verranno trattati all'interno dell'Unione Europea.</p>

				<p><strong>CONSERVAZIONE DEI DATI</strong></p>
				<p>I Dati potranno essere conservati per periodi di tempo diversi a seconda della finalità per la quale vengono raccolti e trattati dal Titolare e, comunque, in conformità alla Normativa Privacy</p>
				<p>In particolare:</p>
				<div>
					<ul>
						<li><u>per la finalità di <em>'contatti'</em></u>, i Dati verranno conservati per il tempo strettamente necessario a fornire all'utente il servizio richiesto, salvi ulteriori obblighi di conservazione previsti dalla legge.</li>
					</ul>
				</div>

				<p><strong>DIRITTI DEGLI INTERESSATI</strong></p>
				<p>I soggetti cui si riferiscono i Dati hanno il diritto in qualunque momento di esercitare i loro diritti ex artt. 15 ss. del Regolamento UE 679/2016 tra i quali: a) diritto ad essere informato delle finalità e modalità del trattamento; b) accesso; c) aggiornamento e rettifica; d) cancellazione, anonimizzazione o blocco; e) opposizione al trattamento; f) revoca del consenso; g) portabilità; h) limitazione al trattamento. I soggetti cui si riferiscono i dati personali hanno inoltre diritto di proporre reclamo all'autorità di controllo.</p>
				<p>Tali diritti potranno essere esercitati contattando direttamente il Titolare all'indirizzo email <u>contatti@kestrelintelligence.it</u> o scrivendo a Kestrel Intelligence di Vitiello Claudio Filippo, Corso Giolitti 17, 12100 - Cuneo (CN), Partita IVA n. 04154210043.</p>

				<p><strong>MODIFICHE ALLA POLICY</strong></p>
				<p>L'eventuale entrata in vigore di nuove normative di settore, come anche il costante esame ed aggiornamento dei servizi all'utente, potrebbe comportare la necessità di variare le modalità di trattamento dei dati personali degli utenti. Pertanto è possibile che la nostra privacy policy subisca modifiche nel tempo ed invitiamo, pertanto, il visitatore a consultare periodicamente questa pagina.</p>

			</Container>
		</>

		

	);

	

}

export default PrivacyPolicy;